module.exports = __webpack_public_path__ + "static/media/top_banner_12.c14604d0.png";